import React, {createContext, useEffect, useState} from "react";

const defaultTreeContext = {}
export const TreeContext = createContext(defaultTreeContext);

export const TreeContextProvider = (props) => {
    const [treeDataContext, setTreeDataContext] = useState([]);
    const [employeesDragPreview, setEmployeesDragPreview] = useState([]);

    useEffect(() => {}, []);

    return <TreeContext.Provider
        value={{
            treeDataContext,
            setTreeDataContext,
            employeesDragPreview,
            setEmployeesDragPreview
        }}
    >
        {props.children}
    </TreeContext.Provider>
}